import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const InputStyle = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    labelWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    label: {
        ...typography.label,
        color: theme.palette.common.black,
    },
    validLabel: {
        color: theme.palette.common.black,
    },
    invalidLabel: {
        color: theme.palette.error.main,
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '0.1875rem',
        border: '1px solid',
        borderColor: theme.palette.common.black,
        outline: 'none',
        background: theme.palette.common.white,
    },
    input: {
        ...typography.input,
        flex: 1,
        minWidth: 0,
        border: 'none',
        borderRadius: '0.1875rem',
        background: theme.palette.common.white,
        padding: theme.spacing(2),
        '&:focus': {
            outline: 'none',
        },
        '&:autofill, &:-webkit-autofill, &:-internal-autofill-selected': {
            ...typography.input,
            backgroundColor: `${theme.palette.common.white} !important`,
        },
        '&:-webkit-autofill': {
            '-webkit-box-shadow': `0 0 0px 1000px ${theme.palette.common.white} inset`,
        },
        '&:-moz-autofill': {
            '-moz-box-shadow': `0 0 0px 1000px ${theme.palette.common.white} inset`,
        },
        '&:-ms-autofill': {
            '-ms-box-shadow': `0 0 0px 1000px ${theme.palette.common.white} inset`,
        },
        '&::placeholder': {
            ...typography.placeholder,
        },
        '&:[type="number"]': {
            appearance: 'none',
        },
    },
    focusedInput: {
        outline: '1px solid',
        borderRadius: '0.1875rem',
        outlineColor: theme.palette.common.black,
        borderColor: theme.palette.common.black,
    },
    invalidInput: {
        outline: '1px solid',
        borderRadius: '0.1875rem',
        outlineColor: theme.palette.error.main,
        borderColor: theme.palette.error.main,
    },
    inputActions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: theme.spacing(1),
        gap: theme.spacing(0.5),
    },
    errorIcon: {
        margin: '3px',
    },
    errorMessage: {
        ...typography.feedback,
        color: theme.palette.error.main,
    },
    dateInput : {
        border: `1px solid ${styleColors.black}`,
        display: 'flex',
        fontSize: '30px',
        padding: '6px',
    },
    dateInputField :{
        border: '0px solid',
        width: '40px',
    }
});



// WEBPACK FOOTER //
// ./src/components/common/input/input.style.ts